import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { SupplierDairySummaryReport } from './Pages';

export const SupplierDairySummaryReportRoutes = ({ match }) => (

    <Fragment>
        <Route exact path = {`${match.path}`} component={SupplierDairySummaryReport} />
    </Fragment>

)